import React from 'react';
import NoDezignShark from './NoDezignShark';
import DezignShark from './DezignShark';
import { useQuery } from 'react-query';
import { getDezignSharkLeads} from '../../api/services';
import { LinearProgress } from '@mui/material';

const DezignSharkPage: React.FC = () => {
    // Fetch DezignShark data
    const { data: DezignSharkData, isLoading: isLoadingDezignShark, error: DezignSharkError, refetch: refetchDezignShark } = useQuery('getDezignShark', getDezignSharkLeads);

    const combinedData = [
        ...(DezignSharkData?.data || []), 
    ];


    if (combinedData.length === 0) {
        return <NoDezignShark />;
    }

    return <DezignShark DezignSharkData={combinedData} onDelete={() => { refetchDezignShark();  }} />;
};

export default DezignSharkPage;
